import _toConsumableArray from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import Vue from 'vue';
import env from '@tencent/vft-common/env';
import { shieldRun } from '@vip-activity/utils';
import { RequestLogicError } from '@tencent/Coa';
import loginService from '../userState/loginService';
import { request } from './request'; // 魔方链接

var baseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity';

var addPrePublish = function addPrePublish() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (window.location.search.indexOf('is_prepublish') > -1) {
    return _objectSpread(_objectSpread({}, params), {}, {
      is_prepublish: 1
    });
  }

  return params;
};
/**
 * 魔方服务封装
 */


var MagicService = /*#__PURE__*/function () {
  function MagicService(actId) {
    _classCallCheck(this, MagicService);

    this.actId = actId;
  }
  /** *
   * 开通套餐
   * @param data：{
        module_id: 模块id,
        real_ptag: ptag,
      }
   * @returns {*}
   */


  _createClass(MagicService, [{
    key: "openVip",
    value: function openVip() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$silent = _ref.silent,
          silent = _ref$silent === void 0 ? false : _ref$silent;

      var options = _objectSpread({
        type: 23,
        option: 3,
        act_id: this.actId
      }, data);

      if (env.isApp && env.isIpad) {
        options.platform = 4;
      } // eslint-disable-next-line @typescript-eslint/no-this-alias


      var vm = this;
      return new Promise(function (resolve, reject) {
        request()(baseUrl, addPrePublish(options)).then(resolve)["catch"](function (e) {
          if (!silent) {
            switch (e.code) {
              case -102:
              case -11:
                loginService.openLogin();
                break;

              case -905:
                // eslint-disable-next-line
                var iRet = e.res.security_verify.iRet;

                if (iRet === 101) {
                  Vue.prototype.toast('您的账号存在风险，请切换账号后重试');
                  break;
                }

                if (iRet === 102 || iRet === 104) {
                  shieldRun(e.res.security_verify, function () {
                    vm.openVip(data).then(resolve)["catch"](reject);
                  }, reject);
                  return;
                }

                break;

              default:
                Vue.prototype.toast("".concat(e.msg || '服务器开小差了', "[").concat(e.code, "]"));
            }
          }

          reject(e);
        });
      });
    }
    /**
     * 新开通
     * @param data：{
          module_id: 模块id,
          real_ptag: ptag,
        }
       @param options{
          silent: 仅查询开通资格，不需要ui上的任何处理,
        }
     */

  }, {
    key: "openVipNew",
    value: function openVipNew() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$silent = _ref2.silent,
          silent = _ref2$silent === void 0 ? false : _ref2$silent,
          _ref2$retry = _ref2.retry,
          retry = _ref2$retry === void 0 ? false : _ref2$retry;

      var options = _objectSpread({
        type: 100190,
        option: 3,
        act_id: this.actId
      }, data);

      if (env.isApp && env.isIpad) {
        options.platform = 4;
      } // eslint-disable-next-line @typescript-eslint/no-this-alias


      var vm = this;
      return new Promise(function (resolve, reject) {
        request({
          retry: retry
        })(baseUrl, addPrePublish(options)).then(resolve)["catch"](function (e) {
          var _e$res, _e$res$frame_resp;

          if (!silent) {
            switch (e.code) {
              case -1002:
                loginService.openLogin();
                break;

              case -905:
                // eslint-disable-next-line
                var _e$res$frame_resp$sec = (_e$res = e.res) === null || _e$res === void 0 ? void 0 : (_e$res$frame_resp = _e$res.frame_resp) === null || _e$res$frame_resp === void 0 ? void 0 : _e$res$frame_resp.security_verify,
                    iRet = _e$res$frame_resp$sec.iRet;

                if (iRet === 101) {
                  Vue.prototype.toast('您的账号存在风险，请切换账号后重试');
                  break;
                }

                if (iRet === 102 || iRet === 104) {
                  shieldRun(e.res.security_verify, function () {
                    vm.openVip(data).then(resolve)["catch"](reject);
                  }, reject);
                  return;
                }

                break;

              default:
                Vue.prototype.toast("".concat(e.msg || '服务器开小差了', "[").concat(e.code, "]"));
            }
          }

          reject(e);
        });
      });
    }
    /** *
     * 获取组合开通
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "getVipOpenMod",
    value: function getVipOpenMod(moduleId) {
      var options = {
        type: 100115,
        option: 1,
        act_id: this.actId,
        module_id: moduleId
      };
      return request()(baseUrl, addPrePublish(options)) // eslint-disable-next-line camelcase
      .then(function (res) {
        var _res$data;

        return res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.match_moudle;
      })["catch"](console.error);
    }
    /** *
     * 获取组合开通  新接口
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "getVipOpenModNew",
    value: function getVipOpenModNew(moduleId) {
      var options = {
        type: 100197,
        option: 1,
        act_id: this.actId,
        module_id: moduleId
      };
      return request()(baseUrl, addPrePublish(options)) // eslint-disable-next-line camelcase
      .then(function (res) {
        return res === null || res === void 0 ? void 0 : res.match_mod;
      })["catch"](console.error);
    }
    /** *
     * 抽奖(处理了安全组件、重试等逻辑，让业务只聚焦逻辑业务逻辑)
     * @param moduleId 模块id
     * @param hitCb 抽中回调
     * @param noHitCb 没有抽中
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function

  }, {
    key: "lottery",
    value: function () {
      var _lottery = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(moduleId) {
        var hitCb,
            noHitCb,
            options,
            vm,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hitCb = _args.length > 1 && _args[1] !== undefined ? _args[1] : function () {};
                noHitCb = _args.length > 2 && _args[2] !== undefined ? _args[2] : function () {};
                options = {
                  type: 21,
                  option: 100,
                  act_id: this.actId,
                  module_id: moduleId
                }; // eslint-disable-next-line @typescript-eslint/no-this-alias

                vm = this;
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  // eslint-disable-next-line camelcase
                  request()(baseUrl, addPrePublish(options)).then(function (_ref3) {
                    var ret = _ref3.ret,
                        data = _ref3.data;
                    var code = +data.sys_code;

                    if (+ret === 0) {
                      if (code === 0) {
                        hitCb(data);
                      } else if (code === -100) {
                        noHitCb(data);
                      } else {
                        Vue.prototype.toast(data.lottery_txt);
                      }

                      resolve(data);
                    } else {
                      Vue.prototype.toast(data.lottery_txt);
                      resolve(data);
                    }
                  })["catch"](function (e) {
                    var ret = e.code;

                    if (+ret === -905) {
                      // 未通过安全策略
                      vm.pullShieldRun(e, function () {
                        vm.lottery(moduleId, hitCb, noHitCb).then(resolve)["catch"](resolve);
                      }, reject);
                      return;
                    }

                    Vue.prototype.toast(e.message || e.msg || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5(".concat(e.code, ")"));
                    reject(e);
                  });
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lottery(_x) {
        return _lottery.apply(this, arguments);
      }

      return lottery;
    }()
    /** *
     * 新抽奖(处理了安全组件、重试等逻辑，让业务只聚焦逻辑业务逻辑)
     * @param data { module_id: 模块ID, nums: 连抽次数 }
     * @param hitCb 抽中回调
     * @param noHitCb 没有抽中
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function

  }, {
    key: "doLottery",
    value: function () {
      var _doLottery = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4) {
        var moduleId,
            nums,
            hitCb,
            noHitCb,
            options,
            vm,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                moduleId = _ref4.module_id, nums = _ref4.nums;
                hitCb = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : function () {};
                noHitCb = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : function () {};
                options = _objectSpread({
                  type: 100143,
                  option: 100,
                  act_id: this.actId,
                  module_id: moduleId
                }, nums ? {
                  nums: nums
                } : null); // eslint-disable-next-line @typescript-eslint/no-this-alias

                vm = this;
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  // eslint-disable-next-line camelcase
                  request()(baseUrl, addPrePublish(options)).then(function (data) {
                    var code = +data.lotter_result;

                    if (+data.ret === 0) {
                      if (code === 1) {
                        hitCb(data);
                      } else if (code === -100) {
                        noHitCb(data);
                      } else {
                        Vue.prototype.toast(data.lotter_ext);
                      }

                      resolve(data);
                    } else {
                      Vue.prototype.toast(data.lotter_ext);
                      resolve(data);
                    }
                  })["catch"](function (e) {
                    var ret = e.code;

                    if (+ret === -905) {
                      // 未通过安全策略
                      vm.pullShieldRun(e, function () {
                        vm.doLottery({
                          module_id: moduleId,
                          nums: nums
                        }, hitCb, noHitCb).then(resolve)["catch"](resolve);
                      }, reject);
                      return;
                    }

                    Vue.prototype.toast(e.message || e.msg || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5(".concat(e.code, ")"));
                    reject(e);
                  });
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function doLottery(_x2) {
        return _doLottery.apply(this, arguments);
      }

      return doLottery;
    }()
    /** *
     * 获取抽奖次数
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "getLotteryInfo",
    value: function getLotteryInfo(moduleId) {
      var options = {
        type: 21,
        option: 101,
        act_id: this.actId,
        module_id: moduleId
      };
      return request()(baseUrl, addPrePublish(options)).then( // eslint-disable-next-line camelcase
      function (res) {
        var _res$data2;

        return res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.left_num;
      });
    }
    /** *
     * 获取 新抽奖 次数
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "getLotteryCount",
    value: function getLotteryCount(moduleId) {
      var options = {
        type: 100143,
        option: 102,
        act_id: this.actId,
        module_id: moduleId
      };
      return request()(baseUrl, addPrePublish(options)).then( // eslint-disable-next-line camelcase
      function (res) {
        var _res$data3;

        return res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.left_nums;
      });
    }
    /** *
     * 获取 新抽奖 奖品列表
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "getLotteryPrizeList",
    value: function getLotteryPrizeList(moduleId) {
      var options = {
        type: 100143,
        option: 101,
        act_id: this.actId,
        module_id: moduleId
      };
      return request()(baseUrl, addPrePublish(options)).then( // eslint-disable-next-line camelcase
      function (res) {
        var _res$data$prize_list, _res$data4;

        return (_res$data$prize_list = res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.prize_list) !== null && _res$data$prize_list !== void 0 ? _res$data$prize_list : [];
      });
    }
    /** *
     * 符合条件跳转
     * @param moduleId
     * @param options 兼容历史代码，增加option，看是否需要返回完整res
     * @returns {*}
     */

  }, {
    key: "checkRuleState",
    value: function () {
      var _checkRuleState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(moduleId) {
        var _ref5,
            _ref5$fullResponse,
            fullResponse,
            _ref5$isRetry,
            isRetry,
            options,
            RetryConfig,
            res,
            _args3 = arguments;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref5 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, _ref5$fullResponse = _ref5.fullResponse, fullResponse = _ref5$fullResponse === void 0 ? false : _ref5$fullResponse, _ref5$isRetry = _ref5.isRetry, isRetry = _ref5$isRetry === void 0 ? {} : _ref5$isRetry;
                options = {
                  type: 7,
                  option: 3,
                  act_id: this.actId,
                  module_id: moduleId
                };
                RetryConfig = _objectSpread({}, isRetry);

                if (isRetry !== null && isRetry !== void 0 && isRetry.retry) {
                  RetryConfig.checkRes = function (res) {
                    if (!(RetryConfig.errMsg && (res === null || res === void 0 ? void 0 : res.ret) in RetryConfig.errMsg)) {
                      var code = res.ret || res.result && res.result.code;
                      var msg = res.msg || res.result && res.result.msg;
                      throw new RequestLogicError(msg, code, res);
                    }

                    return res;
                  };
                }

                _context3.next = 6;
                return request({
                  RetryConfig: RetryConfig
                })(baseUrl, addPrePublish(options)).then(function (result) {
                  return fullResponse ? result : (result === null || result === void 0 ? void 0 : result.ret) === 0;
                })["catch"](function (err) {
                  return fullResponse ? err : false;
                });

              case 6:
                res = _context3.sent;
                return _context3.abrupt("return", res);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkRuleState(_x3) {
        return _checkRuleState.apply(this, arguments);
      }

      return checkRuleState;
    }()
    /** *
     * 是否预约
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "hasBookAct",
    value: function hasBookAct(moduleId) {
      var options = {
        type: 30,
        option: 3,
        act_id: this.actId,
        module_id: moduleId
      };
      return request({
        retry: 1
      })(baseUrl, addPrePublish(options)).then(function (res) {
        return !!res.data.is_book;
      });
    }
    /** *
     * 预约活动
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "bookAct",
    value: function bookAct(moduleId) {
      var options = {
        type: 30,
        option: 104,
        act_id: this.actId,
        module_id: moduleId
      };
      return request()(baseUrl, addPrePublish(options));
    }
    /** *
     * 获取跑马灯内容
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "lotteryFlowList",
    value: function lotteryFlowList(moduleId) {
      var options = {
        type: 100119,
        act_id: this.actId,
        module_id: moduleId,
        page_index: 0,
        page_size: 20
      };
      return request()(baseUrl, addPrePublish(options)).then(function (res) {
        var _res$data5;

        return res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.horseRaceInfos;
      });
    }
    /** *
     * 发起助力
     * @param moduleId
     * @param ptag
     * @param platform
     * @param omgid
     * @returns {*}
     */

  }, {
    key: "createAssist",
    value: function createAssist(moduleId, params) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var vm = this;

      var options = _objectSpread({
        type: 100125,
        act_id: this.actId,
        module_id: moduleId,
        option: 0
      }, params);

      return new Promise(function (resolve, reject) {
        request()(baseUrl, addPrePublish(options)).then(function (ret) {
          resolve({
            ret: ret
          });
        })["catch"](function (e) {
          var ret = e.code;

          if (+ret === -905) {
            // 未通过安全策略
            vm.pullShieldRun(e, function () {
              vm.activeAccept(moduleId, vm.activeAccept(moduleId)).then(resolve)["catch"](resolve);
            }, reject);
            return;
          }

          reject(e);
        });
      });
    }
    /**
     * 获取助力列表(主人态)
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "getAssistList",
    value: function getAssistList(moduleId) {
      var options = {
        type: 100125,
        act_id: this.actId,
        module_id: moduleId,
        option: 1
      };
      return request()(baseUrl, addPrePublish(options));
    }
    /**
     * 获取被助力列表(主人态)
     * @param moduleId
     * @returns {*}
     */

  }, {
    key: "getBeAssistList",
    value: function getBeAssistList(moduleId) {
      var options = {
        type: 100125,
        act_id: this.actId,
        module_id: moduleId,
        option: 4
      };
      return request()(baseUrl, addPrePublish(options));
    }
    /**
     * 为好友助力(客人态)
     * @param moduleId 模块id
     * @param vuid 主人态id
     * @param ptag
     * @param platform
     * @param omgid
     * @returns {*}
     */

  }, {
    key: "doAssist",
    value: function doAssist(moduleId, params) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var vm = this;

      var options = _objectSpread({
        type: 100125,
        act_id: this.actId,
        module_id: moduleId,
        option: 2
      }, params);

      return new Promise(function (resolve, reject) {
        request()(baseUrl, addPrePublish(options)).then(function (ret) {
          resolve({
            ret: ret
          });
        })["catch"](function (e) {
          var ret = e.code;

          if (+ret === -905) {
            // 未通过安全策略
            vm.pullShieldRun(e, function () {
              vm.activeAccept(moduleId, vm.activeAccept(moduleId)).then(resolve)["catch"](resolve);
            }, reject);
            return;
          }

          reject(e);
        });
      });
    }
    /**
     * 检查用户活动领取情况
     */

  }, {
    key: "checkUserAccept",
    value: function checkUserAccept(moduleId) {
      var options = {
        type: 100160,
        option: 101,
        act_id: this.actId,
        module_id: moduleId
      };
      return request()(baseUrl, addPrePublish(options));
    }
    /**
     * 活动领取
     */

  }, {
    key: "activeAccept",
    value: function activeAccept(moduleId, params) {
      var options = _objectSpread({
        type: 100160,
        option: 100,
        act_id: this.actId,
        module_id: moduleId
      }, params); // eslint-disable-next-line @typescript-eslint/no-this-alias


      var vm = this;
      return new Promise(function (resolve, reject) {
        request()(baseUrl, addPrePublish(options)).then(function (_ref6) {
          var result = _ref6.receive_result,
              msg = _ref6.msg;

          // eslint-disable-next-line no-unused-expressions
          if (result) {
            Vue.prototype.toast('领取成功');
            Vue.prototype.$report.expose(Vue.prototype.reportData.module('任务完成领取成功'));
          } else {
            Vue.prototype.toast('领取失败,请重试');
          }

          resolve({
            result: result,
            msg: msg
          });
        })["catch"](function (e) {
          var ret = e.code;

          if (+ret === -905) {
            // 未通过安全策略
            vm.pullShieldRun(e, function () {
              vm.activeAccept(moduleId, vm.activeAccept(moduleId)).then(resolve)["catch"](resolve);
            }, reject);
            return;
          }

          Vue.prototype.toast(e.message || e.msg || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5(".concat(e.code, ")"));
          reject(e);
        });
      });
    } // 拉取安全组件
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "pullShieldRun",
    value: function pullShieldRun(e, success, fail) {
      var _e$res2, _e$res3;

      // eslint-disable-next-line camelcase
      var security_verify = (_e$res2 = e.res) === null || _e$res2 === void 0 ? void 0 : _e$res2.security_verify;

      if ((_e$res3 = e.res) !== null && _e$res3 !== void 0 && _e$res3.frame_resp) {
        var _e$res4, _e$res4$frame_resp;

        // eslint-disable-next-line no-const-assign
        security_verify = (_e$res4 = e.res) === null || _e$res4 === void 0 ? void 0 : (_e$res4$frame_resp = _e$res4.frame_resp) === null || _e$res4$frame_resp === void 0 ? void 0 : _e$res4$frame_resp.security_verify;
      } // eslint-disable-next-line camelcase


      var _security_verify = security_verify,
          iRet = _security_verify.iRet;

      if (iRet === 101) {
        Vue.prototype.confirm({
          msg: '您的账号存在风险，请切换账号重试或联系客服处理',
          confirmText: '联系客服',
          confirm: function confirm() {
            window.location.href = '//kf.qq.com/touch/video/index.html';
          }
        });
        fail(e);
      } else {
        shieldRun(security_verify, success, fail);
      }
    }
    /**
     * 云积分输出 - 兑换列表拉取
     * @param {*} data {
     *  module_id,
     *  page_index: 0,
     *  page_size: 10
     * }
     */

  }, {
    key: "getScoreExchangeList",
    value: function getScoreExchangeList() {
      var _data$page_index, _data$page_size;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = {
        option: 1,
        act_id: this.actId,
        module_id: data.module_id,
        page_index: (_data$page_index = data.page_index) !== null && _data$page_index !== void 0 ? _data$page_index : 0,
        page_size: (_data$page_size = data.page_size) !== null && _data$page_size !== void 0 ? _data$page_size : 10
      };
      return request({
        retry: 2
      })(baseUrl, addPrePublish(params)).then(function (res) {
        return res === null || res === void 0 ? void 0 : res.exchange_rules;
      });
    }
    /**
     * 云积分输出 - 兑换
     * @param {*} data
     * @returns 兑换物品和积分直接抽奖的返回不同
     */

  }, {
    key: "doScoreExchange",
    value: function doScoreExchange() {
      var _data$rule_id;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = {
        option: 2,
        act_id: this.actId,
        module_id: data.module_id,
        rule_id: (_data$rule_id = data.rule_id) !== null && _data$rule_id !== void 0 ? _data$rule_id : ''
      }; // eslint-disable-next-line @typescript-eslint/no-this-alias

      var vm = this;
      return new Promise(function (resolve, reject) {
        request()(baseUrl, addPrePublish(params)).then(resolve)["catch"](function (e) {
          var ret = e.code;

          switch (+ret) {
            case -1000:
              loginService.openLogin();
              break;

            case -905:
              {
                // 未通过安全策略
                vm.pullShieldRun(e, function () {
                  vm.doScoreExchange(data).then(resolve)["catch"](resolve);
                }, reject);
                return;
              }

            default:
              break;
          }

          Vue.prototype.toast(e.message || e.msg || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5(".concat(e.code, ")"));
          reject(e);
        });
      });
    }
    /**
     * 云积分读取
     * @param {*} data {
     *  module_id,
     *  page_index: 0,
     *  page_size: 10
     * }
     */

  }, {
    key: "getScore",
    value: function getScore() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = {
        option: 1,
        act_id: this.actId,
        module_id: data.module_id
      };
      return request({
        retry: 2
      })(baseUrl, addPrePublish(params));
    }
    /**
     * 进页面送奖励
     * @param {*} data {
     *  module_id,
     * }
     */

  }, {
    key: "sendRewardsWhenEnter",
    value: function sendRewardsWhenEnter() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // -100013: 进页面任务到达限次
      var bypassCode = [0, -100013];
      var params = {
        type: 100201,
        option: 2,
        act_id: this.actId,
        module_id: data.module_id
      };
      return request({
        checkRes: function checkRes(res) {
          if ('ret' in res && bypassCode.indexOf(res.ret) === -1) {
            var msg = res.msg,
                code = res.ret;
            throw new RequestLogicError(msg, code, res);
          }

          return res;
        }
      })(baseUrl, addPrePublish(params));
    }
    /**
    * 魔方批量接口
    * @param batch 批量请求体
    * @param mode 批量请求模式，
    *  0或不填: 唯一ID模式 (请求方携带唯一ID, 返回值回传此ID)
    *  1: 生成ID模式 (后台生成唯一ID, 返回值回传此ID)
    *  2: 顺序模式 (返回键为顺序ID, 返回顺序与请求顺序一致)
    * @returns
    */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "batchCgi",
    value: function batchCgi() {
      var batch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref7$isRetry = _ref7.isRetry,
          isRetry = _ref7$isRetry === void 0 ? {} : _ref7$isRetry;

      // console.log(batch);
      var params = {
        batch: _toConsumableArray(batch),
        mode: mode
      };
      return request({
        isRetry: isRetry
      })('//activity.video.qq.com/fcgi-bin/batch_activity', {}, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        data: addPrePublish(params),
        method: 'post'
      });
    }
  }]);

  return MagicService;
}();

export default MagicService;